/**
 * Тема: пользовательский режим (system/light/dark) хранится в localStorage, эффективная
 * схема (light/dark) применяется как `data-theme` на <html>. Те же ключ и логика повторены
 * скриптом public/theme-init.js — он ставит тему ДО загрузки бандла (без моргания).
 */
export type ThemeMode = 'system' | 'light' | 'dark';
export type ResolvedTheme = 'light' | 'dark';

export const THEME_STORAGE_KEY = 'mfo-main-theme';

export function getStoredThemeMode(): ThemeMode {
  try {
    const value = localStorage.getItem(THEME_STORAGE_KEY);
    if (value === 'light' || value === 'dark' || value === 'system') {
      return value;
    }
  } catch {
    // localStorage недоступен — дефолтим на system
  }
  return 'system';
}

export function storeThemeMode(mode: ThemeMode): void {
  try {
    localStorage.setItem(THEME_STORAGE_KEY, mode);
  } catch {
    // localStorage недоступен — режим не переживёт перезагрузку, но UI отработает
  }
}

export function getSystemTheme(): ResolvedTheme {
  return typeof window !== 'undefined' &&
    window.matchMedia('(prefers-color-scheme: dark)').matches
    ? 'dark'
    : 'light';
}

/** Эффективная схема для режима: system → текущая системная, иначе сам режим. */
export function resolveTheme(mode: ThemeMode): ResolvedTheme {
  return mode === 'system' ? getSystemTheme() : mode;
}
